import { post } from './request'

export function adminLogin(data) {
  return post('/api/Admin/Login', data)
}

export function adminList(data) {
  return post('/api/Admin/List', data)
}

export function adminAdd(data) {
  return post('/api/Admin/Add', data)
}

export function adminUpdate(data) {
  return post('/api/Admin/Update', data)
}

export function adminDelete(data) {
  return post('/api/Admin/Delete', data)
}

export function adminResetPassword(data) {
  return post('/api/Admin/ResetPassword', data)
}

export function adminChangePassword(data) {
  return post('/api/Admin/ChangePassword', data)
}
